{
  "articlesSection": "artículos",
  "bookmarkTitleLabel": "Marcadores",
  "communitiesSection": "debates en la comunidad",
  "devConnectionLabel": "Developer Connection",
  "feedback": "Comentarios",
  "fetchFailed": "Se ha producido un error en la captura",
  "help": "Ayuda",
  "helpLoadError": "Se ha producido un error. Inténtelo de nuevo.",
  "noBookmarks": "Para acceder al contenido de ayuda por aquí, márquelo como favorito",
  "noBookmarksTitle": "No hay marcadores",
  "noResults": "No hay resultados",
  "noResultsMessage": "Revise la ortografía o pruebe un término de búsqueda diferente",
  "resourcesCustomerCareLabel": "Servicio de atención al cliente",
  "resourcesStatusLabel": "Estado",
  "solutionsFilterLabel": "Todas las soluciones",
  "support": "Asistencia técnica",
  "videosSection": "vídeos"
}
